{
  "title": "Template items",
  "subtitle": "Reference feature for the frontend conventions",
  "filters": {
    "status": "Status",
    "allStatuses": "All statuses"
  },
  "columns": {
    "name": "Name",
    "price": "Price",
    "status": "Status",
    "createdAt": "Created"
  },
  "status": {
    "active": "Active",
    "archived": "Archived"
  },
  "fields": {
    "name": "Name",
    "price": "Price (USD)"
  },
  "list": {
    "empty": "No items yet",
    "error": "Could not load items. Please try again.",
    "refreshing": "Refreshing"
  },
  "create": {
    "submit": "Add item",
    "success": "Item added",
    "error": "Could not add the item. Please try again."
  },
  "errors": {
    "TEMPLATE_ITEM_NAME_TAKEN": "This name is already used",
    "REQUIRED": "This field is required",
    "INVALID_PRICE": "Enter a price of 0 or more"
  }
}
